import modelBaseV2 from "../model-base-v2.model";

/**
 * Model Management Model
 * 
 * Contains all the requests used by Model Management
 * 
 * @author Darrus Goh
 */
const ModelManagementModel = {

    searchModelDetails: (body) => {
        return modelBaseV2.post('/api/model/detailsearch', { body });
    },

    getModelList: (body) => {
        return modelBaseV2.post('/api/model', { body });
    },

    getModelByCode: (modelCode) => {
        return modelBaseV2.get('/api/model/:modelCode', { params: { modelCode } });
    },

    downloadModelList: (body) => {
        const filename = `ModelManagement_${body.createDateFrom}_${body.createDateTo}_ALL`;
        return modelBaseV2.postDownload('/api/model/excel-download', { body }, filename);
    },

    getModelUDFData: function (params) {
        return modelBaseV2.get('/api/model/udf/data', { params });
    },

    deleteModelUDFData: function (body) {
        return modelBaseV2.post('/api/model/udf/data/delete', { body: body });
    },

    getModelUDFDataDetails: function (modelCode) {
        let params = { modelCode }
        return modelBaseV2.get('/api/model/udf/data/details', { params });
    },

    updateModelUDFData: function (modelCode, body) {
        let queryString = modelBaseV2.toQueryString({ modelCode });
        return modelBaseV2.post(`/api/model/udf/data/update?${queryString}`, { body });
    },

    searchModelAliases: function (body) {
        return modelBaseV2.post(`/api/model/alias`, { body })
    }
}

export default ModelManagementModel;